import Slider, { Settings } from 'react-slick';
import { Box } from '@material-ui/core';

import { t } from 'locales/i18n';

import { AuthPagesSliderItem } from 'features/auth/components/AuthPagesSliderItem';

import InstantlySendImage from 'assets/images/instantly-send-image.png';
import SelfServingSaaSToolImage from 'assets/images/self-serving-saas-tool-image.png';
import EfficiencyAndTransparencyImage from 'assets/images/efficiency-and-transparency-image.png';

import { useStyles } from './styles';

const SLIDES = [
  {
    imageSrc: InstantlySendImage,
    title: t('slider.title1', { ns: 'auth' }),
    subtitle: t('slider.subtitle1', { ns: 'auth' }),
  },
  {
    imageSrc: SelfServingSaaSToolImage,
    title: t('slider.title2', { ns: 'auth' }),
    subtitle: t('slider.subtitle2', { ns: 'auth' }),
  },
  {
    imageSrc: EfficiencyAndTransparencyImage,
    title: t('slider.title3', { ns: 'auth' }),
    subtitle: t('slider.subtitle3', { ns: 'auth' }),
  },
];

const SLIDER_SETTINGS: Settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 6000,
  slidesToShow: 1,
  slidesToScroll: 1,
  touchMove: false,
  autoplay: true,
};

export const AuthPagesSlider = () => {
  const classes = useStyles();

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="space-between"
      className={classes.sliderWrapper}
    >
      <Slider {...SLIDER_SETTINGS}>
        {SLIDES.map((slide, i) => (
          <AuthPagesSliderItem key={i} {...slide} />
        ))}
      </Slider>
    </Box>
  );
};
